import React, { useEffect, useState } from "react";
import {
  getAllGateways,
  setSelectedGateway,
} from "../../../../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import DepositGateway from "./depositGateway";
import { Navigate, useNavigate } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import DepositImg from "../../../../assets/images/icons/dc.png";
import bankImg from "../../../../assets/images/icons/bank.png";
import { getActiveBankDetails } from "../../../../redux/app/actions";
import BackIcon from "../../../../assets/svg/BackIcon";
import { Container } from "react-bootstrap";

const GatewaysList = () => {
  const dispatch = useDispatch();
  const [gatewaysList, setGatewaysList] = useState([]);
  const { bankDetails } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  const isDemoUser = user?.mstruserid === process.env.REACT_APP_DEMO_USER_ID;
  const [gateway, setGateway] = useState("");
  const [formData, setFormData] = useState({});

  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getActiveBankDetails());
    loadGtwsFromServer();
  }, []);

  const loadGtwsFromServer = async () => {
    const response = await getAllGateways();
    const data = response?.data?.data?.data;
    if (data) {
      setGatewaysList(data);
      setGateway(data?.deposits?.[0]?.id || "");
    }
  };

  const handleGatewayClick = (item) => {
    // navigate(`/deposit/${item.id}`);
    setFormData({});
    setGateway(item.id);
  };

  const handleBankTransferClick = () => {
    // navigate(`/deposit/bank_transfer`);
    setFormData({});

    setGateway("bank_transfer");
  };
  return (
    <div>
      {isDemoUser && <Navigate to="/" />}
      <HeaderAfterLogin />
      <main className="main">
        <Container>
          <div className="heading">
            <h2 className="sectionTitle">Deposit</h2>
            <div
              className="back-link"
              style={{ marginTop: "12px" }}
              onClick={() => navigate(-1)}
            >
              Back <BackIcon />
            </div>
          </div>
        </Container>

        <div className="gatewaySection">
          <div className="gatewaypart">
            <div className="left-section">
              <Tabs
                defaultActiveKey="bank"
                id="uncontrolled-tab-example"
                className=""
              >
                <Tab
                  eventKey="bank"
                  title="Self Deposit Option"
                  className="bank_deposit_class"
                >
                  {gatewaysList?.deposits
                    ?.sort((a, b) => a.order - b.order)
                    .map((item, index) => {
                      return (
                        <div
                          className={
                            gateway === item?.id
                              ? `cards1 gatewayActive`
                              : "cards1"
                          }
                          onClick={() => {
                            handleGatewayClick(item);
                          }}
                          key={index}
                        >
                          <div className="card-icon">
                            <img src={item?.logo || DepositImg} />
                          </div>
                          <p>{item?.name}</p>
                        </div>
                      );
                    })}
                  {bankDetails && (
                    <div
                      className={
                        gateway === "bank_transfer"
                          ? `cards1 gatewayActive`
                          : "cards1"
                      }
                      onClick={() => {
                        handleBankTransferClick();
                      }}
                    >
                      {" "}
                      <div className="card-icon">
                        <img src={bankImg} style={{ width: "66px" }} />
                      </div>
                      <p>{"Bank Transfer"}</p>
                    </div>
                  )}
                </Tab>
              </Tabs>
            </div>
            <div className="right-section">
              {gateway !== "" && (
                <DepositGateway
                  gateway={gateway}
                  formData={formData}
                  setFormData={setFormData}
                />
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
export default GatewaysList;
